import { Body1, Button, tokens } from "@fluentui/react-components";
import { InfoFilled } from "@fluentui/react-icons";
import * as React from "react";
import { useIntl } from "react-intl";

import { Flex } from "@tdp/common/fluentV9MigrationComponents";

import { analyticsV2ContainerStyles } from "../AnalyticsContainer.Styles";

export const EmptyState: React.FC<{ failed?: boolean, onClick?: () => void }> = ({ failed = false, onClick }) => {
  const intl = useIntl();
  const errorTextStyle = { color: tokens.colorPaletteRedForeground1 };
  const styles = analyticsV2ContainerStyles();
  const errorMessage = failed ?
    intl.formatMessage({
      defaultMessage: "We can’t get the data right now. Please try again.",
      description: "Error message for failed analytics data retrieval",
    })
    : intl.formatMessage({
      defaultMessage: "No data available",
      description: "Message displayed when there is no data available for analytics",
    });
  const buttonText = failed ?
    intl.formatMessage({
      defaultMessage: "Try again",
      description: "Button text to retry fetching analytics data",
    })
    : intl.formatMessage({
      defaultMessage: "Refresh",
      description: "Button text to refresh analytics data",
    });
  return (
    <Flex fill vAlign="center" hAlign="center" >
      <Flex column className={styles.emptyState} gap="gap.medium" vAlign="center" hAlign="center">
        {failed && <InfoFilled style={errorTextStyle} fontSize={24} />}
        <Body1 style={failed ? errorTextStyle : undefined} align="center">{errorMessage}</Body1>
        {failed && <Button className={styles.emptyStateButton} appearance="primary" onClick={onClick}>{buttonText}</Button>}
      </Flex>
    </Flex>
  );
};
